<template>
  <div class="page">
    <!-- 页面下拉刷新 -->
    <cp-page-refresh @refresh="refresh" ref="pageRefresh">
      <!-- 公共头部组件 -->
      <common-header />
      <div class="container">
        <!-- swiper新闻 -->
        <!-- 如果轮播是图片，点击跳转到课程详情
        如果轮播是视频，点击实现播放和暂停 -->
        <video-swiper
          v-if="bannerList.length"
          :list="bannerList"
          :showBottomMask="false"
          :autoplay="bannerList.length > 1"
          @handle-click-slide="handleClickSlide"
          @handle-click-details="handleClickDetails"
        />
        <!-- 内容卡片 -->
        <div class="card-contain" v-if="oldTimeForToday.summary">
          <div class="card-head">
            <img src="./../../assets/images/icon/sy_history_bg_b.png" />
            <div class="line"></div>
            <img src="./../../assets/images/icon/sy_history_bg_b.png" />
          </div>
          <div class="card-session">
            <h3>历史事件</h3>
            <p v-text="oldTimeForToday.summary">丰富的K12教育课程、各类特色文化课程、海量创作素材资源,一切为课堂而生；海量创作素材资源,一切为课堂而生；聚集个性化课程...</p>
          </div>
          <div class="card-foot">
            <p v-text="oldTimeForToday.date"></p>
            <div class="btn" @click="toDetailsPage(oldTimeForToday.id)">了解详情</div>
          </div>
        </div>
        <!-- 精彩课程 -->
        <div class="wonderful-course-contain">
          <index-common-header title="精彩课程" :query="wonderfulCourseHeaderQuery"/>
          <div class="session">
            <div class="swiper-contains">
              <swiper v-if="goodCourseList.length" :options="swiperOption1" ref="wonderfulSwiper">
                <swiper-slide v-for="(item,index) in goodCourseList" :key="index" :data-id="item.id">
                  <img class="swiper-slide" :src="formatAliyunPath(item.coverImg)+'?x-oss-process=image/resize,p_50'" @click="goodCourseToDetails(item)"/>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <!-- 课程-文本描述 -->
        <div class="company-build-contain" v-if="seriesList.length">
          <img class="bgImg" src="./../../assets/images/icon/sy_jckc_byx.png" />
          <p :class="[(courseActivedItem.id==seriesList[0].id?'bg-left-red':'bg-left-black'),'bg-left']" @click="changeSeries(0)"></p>
          <p v-if="seriesList.length>1" :class="[(courseActivedItem.id==seriesList[1].id?'bg-center-red':'bg-center-black'),'bg-center']" @click="changeSeries(1)"></p>
          <p v-if="seriesList.length>2" :class="[(courseActivedItem.id==seriesList[2].id?'bg-right-red':'bg-right-black'),'bg-right']" @click="changeSeries(2)"></p>
          <div class="session-contain">
            <h3 v-text="courseActivedItem.name"></h3>
            <p v-html="courseActivedItem.remark"></p>
          </div>
        </div>
        <!-- VR课程 -->
        <div class="vr-build-contain">
          <div class="vr-header">
            <index-common-header title="VR课程" theme="light" :query="vrCourseHeaderQuery"/>
          </div>
          <div class="img-contain">
            <div class="item-contain">
              <div class="item" id='ssss'>
                <video id="bgVideo" ref="bgVideo" v-if="vrSummary.bgVideo" :poster="vrSummary.bgVideo+'?x-oss-process=video/snapshot,t_5000,f_jpg'" :src="vrSummary.bgVideo" type="video/mp4" muted controls loop="loop"
                  style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
                  您的浏览器不支持视频播放，请换个浏览器试试
                </video>
                <img v-else-if="vrSummary.imgSrc" width="100%" class="banner-img" :src="vrSummary.imgSrc+'?x-oss-process=image/resize,p_50'"/>
                <video id="bgVideo" ref="bgVideo" v-else :poster="vrSummary.imgUrl" src="../../assets/video/default.mp4" type="video/mp4" muted controls loop="loop"
                  style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
                  您的浏览器不支持视频播放，请换个浏览器试试
                </video>
                <!-- <video id="bgVideo" ref="bgVideo" src="../../assets/video/default.mp4" :poster="vrSummary.imgUrl" type="video/mp4" muted controls loop="loop"
                  style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5">
                  您的浏览器不支持视频播放，请换个浏览器试试
                </video> -->
              </div>
            </div>
            <!-- <video-swiper class="bgImg"
              v-if="vrCourseList.length"
              :list="vrCourseList"
              :showBottomMask="false"
              :autoplay="vrCourseList.length>1"
              :showTopImg="true"
              @handle-change-slide="handleSlideVrChange"
            /> -->
            <div class="top-img" v-if="vrSummary.coverImg">
              <img width="100%" :src="vrSummary.coverImg"/>
            </div>
          </div>
          <div class="session-contain">
            <h3 v-text="vrSummary.name"></h3>
            <p v-text="vrSummary.description"></p>
            <div class="btn">
              <img src="./../../assets/images/icon/vr_button.png" />
              <p @click="onVrExperience(vrSummary)">佩戴VR头盔体验</p>
            </div>
          </div>
        </div>
        <!-- 模型专区 -->
        <div class="model-course-contain">
          <index-common-header title="模型专区" :query="modelCourseHeaderQuery"/>
          <div class="session">
            <div class="swiper-contains">
              <swiper v-if="modelCourseList.length" :options="swiperOption2" ref="modelSwiper">
                <swiper-slide v-for="(item,index) in modelCourseList" :key="index">
                  <div class="model-item" @click="modelCourseToDetails(item)">
                    <div class="img-contain">
                      <img :src="item.coverImage"/>
                    </div>
                    <h3 v-text="item.name"></h3>
                    <p v-text="item.description">电子课程浏览共享 平台同步人教版教材，基 于优质教案</p>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <!-- 全景专区 -->
        <div class="overall-view-course-contain">
          <index-common-header title="全景专区" :query="overallCourseHeaderQuery"/>
          <div class="session">
            <img :src="formatAliyunPath(overViewCourstItem.listImg)" />
            <div class="masking"></div>
            <div class="center-contian">
              <h3 v-text="overViewCourstItem.name"></h3>
              <div class="btn" @click="jumpUrl(overViewCourstItem.jumpUrl)">遨游全景</div>
            </div>
          </div>
        </div>
        <!-- 5G专区 -->
        <div class="other-course-contain">
          <index-common-header title="5G专区" :more="false" :query="fiveGCourseHeaderQuery"/>
          <div class="session">
            <div class="swiper-contains">
              <swiper v-if="fiveGList.length" :options="swiperOption3" ref="otherSwiper">
                <swiper-slide v-for="(item,index) in fiveGList" :key="index">
                  <div class="model-item" @click="to5gURL(item)">
                    <div class="img-contain">
                      <img :src="formatAliyunPath(item.coverImage)" />
                    </div>
                    <h3 v-text="item.name"></h3>
                    <p v-html="item.description"></p>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <van-popup v-model="showQrCode">
              <img class="qrCode" :src="formatAliyunPath(qrCode)" />
            </van-popup>
          </div>
        </div>
      </div>
    </cp-page-refresh>
    <!-- 公共底部tabs -->
    <foot-table />
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
import { Toast } from 'vant'
import CommonHeader from '@/views/layout/common-header'
import FootTable from '@/views/layout/foot-table'
import VideoSwiper from '@/views/components/video-swiper'
// import BaseSwiper from '@/views/components/base-swiper'
import IndexCommonHeader from './components/common-header.vue'
import { home, aliyun } from '@/agent'
import Dict from '@/core/dict'
export default {
  components: {
    'foot-table': FootTable,
    'common-header': CommonHeader,
    'video-swiper': VideoSwiper,
    // 'base-swiper': BaseSwiper,
    'index-common-header': IndexCommonHeader
  },
  data () {
    return {
      wonderfulCourseHeaderQuery: {
        id: '1',
        url: '',
        path: '/course',
        from: 'home',
        session: 'wonderCourse'
      },
      vrCourseHeaderQuery: {
        id: '2',
        url: '',
        path: '/course',
        from: 'home',
        session: 'vrCourse'
      },
      modelCourseHeaderQuery: {
        id: '3',
        url: '',
        path: '/course',
        from: 'home',
        session: 'modelCourse'
      },
      overallCourseHeaderQuery: {
        id: '4',
        url: '',
        path: '/course',
        from: 'home',
        session: 'overallCourse'
      },
      fiveGCourseHeaderQuery: {
        id: '5',
        url: '',
        path: '/course',
        from: 'home',
        session: 'fiveG'
      },
      courseActivedItem: {},
      appMainParams: '',
      displayDimension: 2, // 1应用 2场景
      animate: false,
      showQrCode: false, // 是否显示昌通码
      qrCode: '', // 昌通码url
      bannerList: [], // 首页轮播
      oldTimeForToday: { // 历史上的今天
        date: '',
        summary: '暂无数据',
        id: ''
      },
      seriesList: [], // 课程 系列列表
      goodCourseList: [], // 精品课程列表
      vrCourseList: [], // VR专区的轮播列表
      vrSummary: {}, // VR专区的详情描述
      modelCourseList: [], // 模型专区的列表
      overViewCourstItem: {}, // 全景专区列表
      fiveGList: [], // 5g专题信息列表
      swiperOption1: {
        slideActiveClass: 'my-swiper-base', // 类名
        autoplay: true, // 用户操作swiper之后，是否禁止autoplay
        loop: true,
        effect: 'coverflow',
        centeredSlides: true,
        slidesPerView: 1.2, // 设置slider容器能够同时显示的slides数量
        spaceBetween: 14, // slide之间设置距离
        coverflowEffect: {
          // 切换效果的参数
          rotate: -18, // 做3d旋转时Y轴的旋转角度
          stretch: 2, // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          depth: 140, // slide的位置深度。值越大z轴距离越远，看起来越小。
          modifier: 2.1,
          slideShadows: false // 是否开启slide阴影
        }
      },
      swiperOption2: {
        slideActiveClass: 'my-swiper-base', // 类名
        slidesPerView: 2, // 设置slider容器能够同时显示的slides数量
        spaceBetween: 7,
        autoplay: true, // 用户操作swiper之后，是否禁止autoplay
        loop: true
      },
      swiperOption3: {
        slideActiveClass: 'my-swiper-base', // 类名
        slidesPerView: 2, // 设置slider容器能够同时显示的slides数量
        spaceBetween: 7,
        autoplay: true, // 用户操作swiper之后，是否禁止autoplay
        loop: true
      }
    }
  },
  watch: {
    courseActivedItem (val) {
      if (val) {
        this.getGoodCourseList(val.id)// 首页精选课程
        this.wonderfulCourseHeaderQuery.id = val.id
        // this.wonderfulCourseHeaderQuery.session = val.name == '建党课程' ? 'partyCourse' : (val.name == '建国课程' ? 'companyCourse' : (val.name == '特色课程' ? 'featuresCourse' : 'partyCourse'))
        this.wonderfulCourseHeaderQuery.session = val.id == '1' ? 'partyCourse' : (val.id == '2' ? 'companyCourse' : (val.id == '4' ? 'featuresCourse' : (val.id == '36' ? 'politicalCourse' : 'partyCourse')))
      }
    }
  },
  mounted () {
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    // 设置滚动条位置
    const scrollTop = Math.abs(document.querySelector('.page').getBoundingClientRect().top)
    this.$util.setTabsLeaveSite(from.path, scrollTop)
    next()
  },
  methods: {
    init () {
      this.getIndexPageSwiperList()// 首页顶部轮播
      this.getOldTimeForToday()// 历史上的今天
      this.getSeriesList()// 系列列表（建党、建军、建国）
      this.getVrSceneMsgList()// VR专区列表
      this.getModelList()// 模型专区
      this.getAllViewList()// 全景专区
      this.get5GMsg()// 5g专题信息
      this.getChangTongCode()// 获得昌通码
    },
    videoInBrowserHandler () {
      this.videoPlay(true)
      document.body.removeEventListener('touchstart', this.videoInBrowserHandler)
    },
    videoPlay (isPlay) {
      var media = document.getElementById('bgVideo')
      if(media){
        if (isPlay && media.paused) {
          media.play()
        }
        // if (!isPlay && !media.paused) {
        //   media.pause()
        // }
      }
    },
    // 下拉刷新页面
    refresh () {
      // this.$refs.typeTabs.handleToIndex(0) // 设置新闻分类默认选中第一个
      Object.assign(this.$data, this.$options.data()) // 重置data的数据为初始状态
      this.$refs.pageRefresh.hideFresh() // 隐藏下拉刷新
      this.init()
      this.changeSeries(0)
    },
    // 首页顶部轮播
    getIndexPageSwiperList () {
      this.$loading.show()
      const params = {
        pageNum: 1,
        pageSize: 10,
        query: {
          typeId: 1
        },
        sorts: [
          { sortPropertyName: 'orderNbr', sortType: 'ISNULL' },
          { sortPropertyName: 'orderNbr', sortType: 'ASC' }
        ]
      }
      home.getIndexPageSwiperList(params).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.bannerList = res.data.list.map(item => {
            switch (item.categoryType) {
              case 1: {
                item.bgVideo = ''
                item.imgSrc = item.src
                break
              }
              case 2: {
                item.bgVideo = item.src
                item.imgSrc = ''
                break
              }
            }
            return item
          })
          // this.bannerList = [{
          //   id:'1',
          //   bgVideo:'/group1/M00/00/1C/rBB5F2DJj5mAZbZKBkTCyzUf7K0905.mp4',
          //   imgSrc:''
          // },{
          //   id:'2',
          //   bgVideo:'',
          //   imgSrc:''
          // }]
        }
      })
    },
    // 历史上的今天
    getOldTimeForToday () {
      this.$loading.show()
      home.getOldTimeForToday().then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          if (res.data.summary) {
            if (res.data.year || res.data.month || res.data.day) {
              this.oldTimeForToday.date = (res.data.year ? (res.data.year + '年') : '') + (res.data.month ? ((res.data.month + '月') + (res.data.day ? (res.data.day + '日') : '')) : '')
            }
            // let timeObj = this.$util.timestampToTime()
            // this.oldTimeForToday.date = timeObj.month + '月' + timeObj.day + '日'
            this.oldTimeForToday.summary = res.data.summary
            this.oldTimeForToday.id = res.data.id
          } else {
            this.oldTimeForToday.summary = ''
          }
        }
      })
    },
    // 系列列表（建党、建军、建国）
    getSeriesList () {
      this.$loading.show()
      const params = {
        query: {
          type: 1,
          visible: 1
        },
        sorts: [
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ISNULL'
          }, {
            sortPropertyName: 'orderNbr',
            sortType: 'ASC'
          }, {
            sortPropertyName: 'modifyTime',
            sortType: 'DESC'
          }
        ]
      }
      home.getSeriesList(params).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.seriesList = res.data
          if (this.seriesList.length) {
            if (this.seriesList.length >= 3) {
              this.courseActivedItem = this.seriesList[1]
            } else {
              this.courseActivedItem = this.seriesList[0]
            }
          }
        }
      })
    },
    // 首页精选课程
    getGoodCourseList (id) {
      this.goodCourseList = []
      this.$loading.show()
      home.getGoodCourseList(id).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.goodCourseList = res.data
        }
      })
    },
    changeSeries (val) {
      console.log(val)
      this.courseActivedItem = this.seriesList[val]
    },
    // VR专区列表
    getVrSceneMsgList () {
      this.$loading.show()
      home.getVrSceneMsgList().then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.appMainParams = res.data.appMainParams
          this.displayDimension = res.data.displayDimension
          if (res.data.displayDimension == 1) { // 获取item中的属性作为 detailList的第一个-应用
            let obj = {
              bgVideo: this.formatAliyunPath(res.data.videoSrc),
              displayDimension: res.data.displayDimension,
              imgSrc: res.data.listImg,
              description: res.data.appMainDescription,
              name: res.data.appMainName,
              showType: res.data.showType,
              coverImg: res.data.coverImg,
            }
            this.vrCourseList[0] = obj
          } else if (res.data.displayDimension == 2) { // 直接获取 detailList-场景
            res.data.detailList.forEach((item) => {
              if (item.showType) {
                item.imgSrc = this.formatAliyunPath(item.listImg)
                item.coverImg = this.formatAliyunPath(item.coverImg)
                this.vrCourseList.push(item)
              }
            })
          }
          this.vrSummary = this.vrCourseList[0]
          // window.addEventListener('touchstart', this.videoInBrowserHandler)
          // if(!this.vrSummary.imgSrc){
          //   // this.vrSummary.imgUrl=this.findvideocover()
          // }
          // this.findvideocover().then(res=>{
          //   this.vrCourseList[0].imgUrl=res
          //   this.vrSummary = this.vrCourseList[0]
          //   this.$forceUpdate()
          // })
        }
      })
    },
    // 模型专区
    getModelList () {
      this.$loading.show()
      let param = {
        pageNum: 1,
        pageSize: 5,
        query: {
          isIndexShow: 1
        },
        sorts: [
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ASC'
          },
          {
            sortPropertyName: 'modifyTime',
            sortType: 'DESC'
          }
        ]
      }
      home.getModelList(param).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.modelCourseList = res.data.list.map(item => {
            item.coverImage = this.formatAliyunPath(item.coverImage)
            return item
          })
        }
      })
    },
    // 全景专区
    getAllViewList () {
      this.$loading.show()
      home.getAllViewList().then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.overViewCourstItem = res.data
        }
      })
    },
    // 5g专题信息
    get5GMsg () {
      this.$loading.show()
      const params = {
        query: {},
        pageNum: 1,
        pageSize: 10,
        sorts: [
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ASC'
          }
        ]
      }
      home.get5GMsg(params).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.fiveGList = res.data
        }
      })
    },
    getChangTongCode () {
      const params = {
        pageNum: 1,
        pageSize: 10,
        query: {
        }
      }
      home.getChangTongCode(params).then((res) => {
        if (res.code == 100) {
          if (res.data) {
            // 没有昌通码数据或者二维码为空
            if (!res.data.list.length || !res.data.list[0].qrCode) {
              this.fiveGList.forEach((item, index) => {
                if (item.name == '昌通码') {
                  this.fiveGList.splice(index, 1)
                }
              })
            } else {
              this.qrCode = res.data.list[0].qrCode
            }
          }
        }
      })
    },
    // 历史上的今天-查看详情-跳到详情页
    toDetailsPage (id) {
      // 路由跳转
      this.$router.push({
        path: '/story/detail',
        query: {
          id: id,
          type: Dict.pageType.memory
        }
      })
    },
    // VR专区-头盔体验
    onVrExperience (item) {
      const param = {
        app: this.appMainParams,
        msg: 'OpenAppAndScene',
        point: this.displayDimension === 1 ? 0 : item.point,
        scene: this.displayDimension === 1 ? 0 : item.params
      }
      home.getSocketapiVr(param).then((res) => {
        if (res.data.data == 100) {
          Toast.success(res.data.data)
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    // 顶部轮播-点击跳转到详情页
    handleClickDetails (item) {
      console.log(item)
      switch (item.jumpType) { // 直接跳返回的url
        case 1: {
          if (item.url) {
            window.open(item.url, '_blank')
          }
          break
        }
        case 2: { // 通用详情-如历史事件
          this.toDetailsPage(item.id)
          break
        }
        case 3: { // 通用详情-如历史事件
          let pathInfo = this.$router.resolve({
            path: '/story/detail',
            query: {
              id: item.id,
              type: Dict.pageType.advertisement
            }
          })
          window.open(pathInfo.href, '_blank')
          break
        }
      }
    },
    // 精彩课程-点击跳转到详情页
    goodCourseToDetails (item) {
      this.$router.push({
        path: '/course/detail',
        query: {
          id: item.id,
          backPath: 'home',
          type: Dict.pageType.inform
        }
      })
    },
    // 模型课程-点击跳转到详情页
    modelCourseToDetails (item) {
      console.log(item)
      localStorage.setItem('playerCyData', JSON.stringify(item))
      this.$router.push({ path: '/model', query: { modelId: item.id, backPath: 'home' } })
    },
    // vr专区轮播-发生变化
    handleSlideVrChange (id) {
      for (let i = 0; i < this.vrCourseList.length; i++) {
        if (this.vrCourseList[i].id == id) {
          this.vrSummary = this.vrCourseList[i]
          break
        }
      }
    },
    // 遨游全景
    jumpUrl (link) {
      window.open(link, '_blank')
    },
    // 5g专区-查看详情
    to5gURL (item) {
      if (item.name !== '昌通码') {
        window.open(item.url, '_blank')
      } else {
        this.showQrCode = true
      }
    },
    goContentWebview () {
      this.$router.push({ path: '/content-webview',
        query: {
          type: 'video',
          url: '@/assets/video/demo.mp4'
        }
      })
    },
    // 点击新闻swiper
    handleClickSlide (id) {
      console.log(id)
      for (let i = 0; i < this.bannerList.length; i++) {
        if (this.bannerList[i].id == id) {
          this.handleClickDetails(this.bannerList[i])
          break
        }
      }
    },
    toListPage (index) { // 点击查看更多，跳到对应的列表页
      this.$router.push({
        path: '/course',
        query: { tabIndex: index }
      })
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
    findvideocover() {
      return new Promise(function (resolve, reject) {
        let video = document.getElementById("bgVideo") // 获取视频对象
        // let video = document.createElement("video")
        // video.src=url // url地址 url跟 视频流是一样的
        var canvas = document.createElement("canvas") // 创建 canvas 对象
        let ctx = canvas.getContext('2d'); // 绘制2d
        video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
        video.currentTime = 4 // 第一帧
        video.oncanplay = () => {
          canvas.width = video.clientWidth; // 获取视频宽度
          canvas.height = video.clientHeight; //获取视频高度
          // 利用canvas对象方法绘图
          ctx.drawImage(video, 0, 0, video.clientWidth,video.clientHeight)
          // 转换成base64形式
          let imgsrc = canvas.toDataURL("image/png") // 截取后的视频封面
          resolve(imgsrc);
        }

      });
    }
  }
}
</script>

<style lang="scss" scoped>
.head{
  margin-bottom: 20px;
  padding: 0 20px;
  .title{
    display: flex;
    justify-content: space-between;
    .left-contain{
      display: flex;
      justify-content: space-between;
      .icon{
        width: 2px;
        height: 15px;
        opacity: 1;
        background: #e50914;
        border-radius: 1px;
      }
      p{
        opacity: 1;
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #282828;
        line-height: 15px;
        margin-left: 8px;
      }
    }
    .right-contain{
      display: flex;
      justify-content: space-between;
      .black{
        width: 16px;
        height: 16px;
        opacity: 1;
        background: #1c1f25;
      }
      .red{
        width: 30px;
        height: 16px;
        opacity: 1;
        background: #e50914;
        margin-left: 2px;
      }
    }
  }
  .more{
    opacity: 1;
    font-size: 9px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: center;
    color: #1c1f25;
    line-height: 15px;
    letter-spacing: 0px;
    text-align: right;
    margin-top: 10px;
  }
}
.page {
  width: 100%;
  .container {
    padding: $header-height 0 $foot-table-height;
    background: #f2f2f2;
  }
  .card-contain{
    width: 335px;
    height: 200px;
    opacity: 1;
    background: #fff;
    border-radius: 10px;
    box-shadow: -5px 0px 0px NaNpx rgba(37,37,37,0.12);
    margin: 20px auto 46px;
    box-sizing: border-box;
    .card-head{
      padding:0 10px;
      box-sizing: border-box;
      height: 10px;
      width:100%;
      display: flex;
      justify-content: space-between;
      .line{
        width: 60px;
        height: 5px;
        opacity: 1;
        background: #252525;
        border-radius: 3px;
        margin-top: 10px;
      }
      img{
        width: 35px;
        height: 10px;
      }
    }
    .card-session{
      padding: 0 34px;
      box-sizing: border-box;
      margin-bottom: 20px;
      h3{
        margin: 27px 0 24px 0;
        opacity: 1;
        font-size: 20px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #1c1f25;
        line-height: 15px;
        letter-spacing: 1px;
      }
      p{
        opacity: 1;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #828282;
        line-height: 20px;
        letter-spacing: 0px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    .card-foot{
      padding:0 33px;
      display: flex;
      justify-content: space-between;
      p{
        opacity: 1;
        font-size: 10px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #1c1f25;
        line-height: 15px;
        letter-spacing: 0px;
        padding-top:12px;
      }
      .btn{
        width: 80px;
        height: 32px;
        opacity: 1;
        background: #e50914;
        border-radius: 2px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #f2f2f2;
        line-height: 32px;
      }

    }
  }
  .wonderful-course-contain{
    margin-bottom: 36px;
    .session{
      height: 180px;
    }
  }
  .company-build-contain{
    position: relative;
    .bgImg{
      width: 100%;
      height: auto;
      display: block;
    }
    .bg-center{
      position: absolute;
      left: 50%;
      transform: translate(-50%,0);
      opacity: 1;
      border-radius: 50%;
      overflow: hidden;
    }
    .bg-center-black{
      top: -4px;
      width: 8px;
      height: 8px;
      background: #1c1f25;
    }
    .bg-center-red{
      top:-7.5px;
      width: 15px;
      height: 15px;
      background: #e50914;
    }

    .bg-left{
      position: absolute;
      left: 30%;
      transform: translate(-50%,0);
      opacity: 1;
      border-radius: 50%;
      overflow: hidden;
    }
    .bg-left-black{
      top: 4px;
      width: 8px;
      height: 8px;
      background: #1c1f25;
    }
    .bg-left-red{
      top: 0;
      width: 15px;
      height: 15px;
      background: #e50914;
    }
    .bg-right{
      position: absolute;
      right: 30%;
      transform: translate(-50%,0);
      opacity: 1;
      border-radius: 50%;
      overflow: hidden;
    }
    .bg-right-black{
      top: 2px;
      width: 8px;
      height: 8px;
      background: #1c1f25;
    }
    .bg-right-red{
      top: -4px;
      width: 15px;
      height: 15px;
      background: #e50914;
    }
    .session-contain{
      text-align: center;
      position: relative;
      h3{
        position: absolute;
        top:10px;
        left: 50%;
        transform: translate(-50%,0);
        opacity: 1;
        font-size: 17px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: center;
        color: #1c1f25;
        line-height: 15px;
        letter-spacing: 1px;
        margin-bottom: 20px;
      }
      p{
        padding:50px 100px 0 100px;
        opacity: 1;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #828282;
        line-height: 18px;
        letter-spacing: 0px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  .vr-build-contain{
    width: 100%;
    height: 817px;
    background: url(./../../assets/images/icon/sy_vr_bg.png) no-repeat center;
    background-size: 100% 100%;
    margin-bottom: 40px;
    .vr-header{
      padding-top: 174px;
      margin: 6px;
    }
    .img-contain{
      height: 280px;
      padding:0 27px;
      box-sizing: border-box;
      background: url(./../../assets/images/icon/vrkc_dt_center.png) no-repeat center;
      background-size: 100% 100%;
      position: relative;
      .item-contain{
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-49.6%);
        width: 85.5%;
        height: 180px;
        .item{
          img{
            width: 100%;
            height: 180px;
            display: block;
          }
        }
      }
      .bgImg{
        width: 100%;
        height: 180px;
        padding-top: 51.315px;
      }
      .top-img{
        position: absolute;
        top: 36%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 2;
        width: 71.6%;
        img{
          width: 100%;
          display: block;
        }
      }
    }
    .session-contain{
      text-align: center;
      h3{
        opacity: 1;
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 15px;
        letter-spacing: 1px;
        margin-bottom: 30px;
      }
      p{
        width: 100%;
        box-sizing: border-box;
        padding: 0 53px;
        opacity: 1;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #828282;
        line-height: 24px;
        letter-spacing: 0px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        line-clamp: 6;
        -webkit-box-orient: vertical;
        margin-bottom: 10px;
      }
      .btn{
        width: 140px;
        position: relative;
        margin: 0 auto;
        img{
          width: 100%;
          height: auto;
          display: block;
        }
        p{
          padding: 0;
          position: absolute;
          top:26%;
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          letter-spacing: 0px;
        }
      }
    }
  }
  .model-course-contain{
    margin-bottom: 36px;
    .session{
      padding: 0 21px;
      .model-item{
        height: 224px;
        width: 164px;
        opacity: 1;
        background: #ffffff;
        border-radius: 2px;
        padding: 24px;
        box-sizing: border-box;
        .img-contain{
          width: 105px;
          height: 76px;
          overflow: hidden;
          margin: 0 auto;
          img{
            height: 100%;
            width: auto;
            display: block;
            opacity: 1;
            margin: 0 auto;
          }
        }
        h3{
          opacity: 1;
          font-size: 17px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #1c1f25;
          letter-spacing: 1px;
          margin: 20px 0 13px 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        p{
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #828282;
          letter-spacing: 0px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .overall-view-course-contain{
    margin-bottom: 36px;
    .session{
      width: 335px;
      min-height: 140px;
      margin: 0 auto;
      position: relative;
      img{
        width: 100%;
        height: auto;
        display: block;
      }
      .masking{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
      }
      .center-contian{
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        h3{
          width: 100%;
          opacity: 1;
          font-size: 20px;
          font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #ffffff;
          line-height: 50px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          margin: 0 auto;
        }
        .btn{
          width: 80px;
          height: 32px;
          opacity: 1;
          background: #e50914;
          border-radius: 1px;
          text-align: center;
          line-height: 32px;
          color: #f2f2f2;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Light;
          font-weight: 300;
          margin: 0 auto;
        }
      }
    }
  }
  .other-course-contain{
    margin-bottom: 36px;
    .session{
      padding: 20px;
      .model-item{
        height: 200px;
        width: 164px;
        box-sizing: border-box;
        opacity: 1;
        background: #ffffff;
        border-radius: 2px;
        padding: 24px;
        box-sizing: border-box;
        .img-contain{
          width: 105px;
          height: 45px;
          overflow: hidden;
          margin: 0 auto;
          img{
            height: 100%;
            width: auto;
            display: block;
            opacity: 1;
            margin: 0 auto;
          }
        }
        h3{
          opacity: 1;
          font-size: 17px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #1c1f25;
          letter-spacing: 1px;
          margin: 20px 0 13px 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        p{
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #828282;
          letter-spacing: 0px;
          line-height: 20px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
    .qrCode{
      display: block;
      width: 120px;
      height: auto;
    }
  }
}
</style>
<style lang='scss'>
  .vr-build-contain{
    .swiper-base .banner-img {
      border-radius:0;
    }
}
</style>
